import { render } from "./AddonViewFullTextList.vue?vue&type=template&id=7e1c8c89&scoped=true&ts=true"
import script from "./AddonViewFullTextList.vue?vue&type=script&lang=ts"
export * from "./AddonViewFullTextList.vue?vue&type=script&lang=ts"

import "./AddonViewFullTextList.vue?vue&type=style&index=0&id=7e1c8c89&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e1c8c89"]])

export default __exports__